import { connect } from 'react-redux'

import { filterChangedAction, selectAction, searchChangedAction, searchResultsArrived, waitForServerAction } from './actions'
import FilterComponent from './FilterComponent'

const mapStateToProps = state => {
  return {
    places: state.places,
    selected: state.selected,
    searchResults: state.searchResults,
    filteredResults: state.filteredResults,
    showingFilters: state.showingFilters,
    isWaitingForResponse: state.isWaitingForResponse,
    authorizedUser: state.authorizedUser,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSelectClick: selected => dispatch(selectAction(selected)),
    onSearchChange: value => dispatch(searchChangedAction(value)),
    onSearchResults: results => dispatch(searchResultsArrived(results)),
    onFilterResults: results => dispatch(filterChangedAction(results)),
    waitingForResponse: status => dispatch(waitForServerAction(status)),
  }
}

const FilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterComponent)

export default FilterContainer



// WEBPACK FOOTER //
// ./src/FilterContainer.js